import { getRequest, postRequest } from 'config/Axios/baseConfig';
import {
  constrainedForecastBulkUpdateInterface,
  constrainedForecastStatusInterface,
  constrainedForecastViewInterface,
} from 'Interfaces/FDPInterfaces/constrainedForecast';
import {
  bulkEditDataInterface,
  filterPayloadInterface,
} from 'Interfaces/FDPInterfaces/constrainedForecastBulkEdit';

export const constrainedForecastService = {
  getConstrainedForecast: (
    ndc: string,
    planning_period: string
  ): Promise<constrainedForecastViewInterface> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<constrainedForecastViewInterface>(
          `fdp/get_constrained_forecast/${planning_period}/${ndc}`
        );
        resolve(data);
      } catch (error) {
        console.log('in services > getConstrainedForecast, Err===', error);
        reject(error);
      }
    });
  },

  getConstrainedForecastStatus: (gfc: number): Promise<constrainedForecastStatusInterface[]> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<constrainedForecastStatusInterface[]>(
          `fdp/get_constrained_status/${gfc}`
        );
        resolve(data);
      } catch (error) {
        console.log('in services > getConstrainedForecastStatus, Err===', error);
        reject(error);
      }
    });
  },

  getBulkNDCList: (): Promise<constrainedForecastBulkUpdateInterface> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<constrainedForecastBulkUpdateInterface>(
          `fdp/get_constrained_status_all`
        );
        resolve(data);
      } catch (error) {
        console.log('in getConstrainedForecast > getBulkNDCList, Err===', error);
        reject(error);
      }
    });
  },

  getConstrainedForecastProgress: (): Promise<{ percentage: number }> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<{ percentage: number }>(
          `fdp/get_constrained_forecast_progress`
        );
        resolve(data);
      } catch (error) {
        console.log('in services > getConstrainedForecastProgress, Err===', error);
        reject(error);
      }
    });
  },

  getConstrainedForecastPlanningPeriods: (gfc: number): Promise<string[]> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<string[]>(`fdp/get_constrained_planning_period/${gfc}`);
        resolve(data);
      } catch (error) {
        console.log('in services > getConstrainedForecastPlanningPeriods, Err===', error);
        reject(error);
      }
    });
  },

  saveConstrainedForecast: (
    payload: {
      NDC11: string;
      PlanningPeriod: string;
      ForecastPeriod: string;
      UnconstrainedForecast: number;
      ConstrainedForecast: number;
      Adjustment: number;
      Notes: string;
    }[]
  ): Promise<{ data: string }> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<{ data: string }>(
          `fdp/constrained_forecast_save`,
          payload
        );
        resolve(data);
      } catch (error) {
        console.log('in services > saveConstrainedForecast, Err===', error);
        reject(error);
      }
    });
  },

  bulkUpdateNDCs: (payload: {
    ndc_list: string[];
    planning_period: string;
    user: string;
  }): Promise<{ data: string }> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<{ data: string }>(
          `fdp/bulk_update_constrained_forecast`,
          payload
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getFilteredData: (
    payload: filterPayloadInterface,
    signal: AbortController['signal'] | null = null
  ): Promise<bulkEditDataInterface[] | []> => {
    return new Promise(async (resolve, reject) => {
      try {
        if (signal) {
          const { data } = await postRequest<bulkEditDataInterface[] | []>(
            `fdp/get_constrained_forecast_bulk_edit_data`,
            payload
          );
          resolve(data);
        } else {
          const { data } = await postRequest<bulkEditDataInterface[] | []>(
            `fdp/get_constrained_forecast_bulk_edit_data`,
            payload
          );
          resolve(data);
        }
      } catch (error) {
        console.log('in services > getFilteredData, Err===', error);
        reject(error);
      }
    });
  },

  getNDC11Suggestions: (
    query: string,
    signal: AbortSignal | undefined = undefined
  ): Promise<string[]> => {
    return new Promise(async (resolve, reject) => {
      try {
        if (signal) {
          const { data } = await postRequest<string[]>(
            `fdp/get_constrained_ndc_suggestions`,
            { query },
            undefined,
            { signal }
          );
          resolve(data);
        } else {
          await postRequest<string[]>(
            `fdp/get_constrained_ndc_suggestions`,
            { query },
            undefined,
            { signal }
          );
        }
      } catch (error) {
        console.log('in services > getNDC11Suggestions, Err===', error);
        reject(error);
      }
    });
  },
};
